import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {

  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'moduleLabel',
      label: i18n.t('common_words.module'),
      minWidth: 200,
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };
  return { Table, Search };
};

export default configTable;
